<template>
  <div>
    <v-dialog v-model="showModal" max-width="60%">
      <customer-address
        :add="true"
        :is-new="true"
        @close="closeAddress"
      ></customer-address>
    </v-dialog>
    <v-card flat>
        <v-layout>
          <v-flex xs12>
            <vonex-select
              v-model="addressID"
              label="Assign Address"
              :items="address.addresses"
              item-value="addressID"
              item-text="formattedAddress"
              class="ml-8"
              :name="'streetAddress'"
              :options="fieldConditions"
              @change="onChange"
            />
          </v-flex>
          <v-flex>
            <v-btn color="primary" @click="openDialog">New Address</v-btn>
          </v-flex>
        </v-layout>
    </v-card>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
import { mapHardwareFields } from '../store/modules/orders';
const { mapActions: mapAddressActions } =
  createNamespacedHelpers(`orders/address`);
const { mapActions: mapHardwareActions } =
  createNamespacedHelpers(`orders/hardware`);
const { mapActions: mapInternetActions, mapMutations: mapInternetMutations } =
  createNamespacedHelpers(`orders/internet`);
export default {
  name: 'Address',
  props: {
    addressId: { type: Number },
  },
  data: function () {
    return {
      showModal: false,
      showContact: false,
      highlight: false,
      isNew: false,
      hardware: [],
      addressID: 0,
    };
  },
  computed: {
    ...mapOrderState(['address', 'isResidential']),
  },
  watch: {
    addressId(newValue) {
      this.addressID = newValue;
      this.$emit('setAddress', newValue);
    },
  },

  methods: {
    ...mapAddressActions([
      'resetAddress',
      'getAddress',
      'addAddress',
      'updateAddress',
      'getAllAddresses',
    ]),
    ...mapHardwareActions(['saveHardware', 'setMessage', 'getHandsetsOnOrder']),
    ...mapInternetActions(['addContacts', 'getContacts']),
    ...mapInternetMutations(['addContact']),
    closeAddress(payload) {
      this.isNew = false;
      this.showModal = false;
      if (payload != null) {
        this.addressID = payload;
      }
    },
    onChange(data) {
      this.$emit('setAddress', data);
      this.addressID = -1;
    },
    openDialog() {
      this.isNew = true;
      this.showModal = true;
    },
  },

};
</script>
<style scoped lang="scss">
.bounce-enter-active {
  animation: bounce-in 1.5s;
}
.bounce-leave-active {
  animation: bounce-in 1.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.custom-address {
  ::v-deep .v-text-field {
    padding-top: 0;
    margin-top: 0;
  }
}

.custom-name {
  ::v-deep .v-text-field {
    margin-top: 0;
  }
}
</style>
